"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _config = require("./config");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'IconButton',
  props: {
    tip: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    },
    mold: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'mini'
    },
    type: {
      type: String,
      default: ''
    },
    plain: {
      type: Boolean,
      default: false
    },
    round: {
      type: Boolean,
      default: false
    },
    circle: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    nativeType: {
      type: String,
      default: 'button'
    }
  },
  data: function data() {
    return {
      style: {},
      moldConfig: _config.BUTTON_CONFIG,
      buttonType: 'primary',
      buttonIcon: ''
    };
  },
  created: function created() {
    if (this.color) {
      this.style = {
        background: this.color,
        border: "1px solid ".concat(this.color)
      };
    }
    if (this.mold) {
      this.buttonType = this.type ? this.type : this.moldConfig[this.mold] ? this.moldConfig[this.mold].type : this.type;
      this.buttonIcon = this.icon ? this.icon : this.moldConfig[this.mold] ? this.moldConfig[this.mold].icon : this.icon;
    }
  },
  methods: {
    click: function click() {
      this.$emit('click');
    }
  }
};
exports.default = _default;